import template from './managerAcceptAll.html';
import controller from './managerAcceptAll.controller';
import './managerAcceptAll.scss';

let managerAcceptAllComponent = {
  restrict: 'E',
  bindings: {
    request: '<',
    requestCount: '<',
    setAction: '&',
    isMobileApp: '<',
  },
  template,
  controller,
};

export default managerAcceptAllComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/managerAcceptAll/managerAcceptAll.component.js